export const ASSET_SCOPE_FILTER = {
  IN_SCOPE: 'IN_SCOPE',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
} as const;

export type AssetScopeFilterValue =
  | typeof ASSET_SCOPE_FILTER.IN_SCOPE
  | typeof ASSET_SCOPE_FILTER.OUT_OF_SCOPE;

export function parseAssetScopeFilter({
  value,
}: {
  value?: string | null;
}): AssetScopeFilterValue | undefined {
  if (
    value === ASSET_SCOPE_FILTER.IN_SCOPE ||
    value === ASSET_SCOPE_FILTER.OUT_OF_SCOPE
  ) {
    return value;
  }

  return undefined;
}
